import { Link } from "react-router-dom"

export default function Footer() {
    const currentYear = new Date().getFullYear()

    return (
        <footer className="footer mt-5 py-3 bg-body-tertiary mt-3">
            <div className="row">
                <nav className="nav justify-content-between">
                    <Link
                        id="location-status"
                        className="nav-link disabled"
                        style={{ fontSize: "0.8rem" }}
                        aria-disabled="true"
                        to={`/`}
                    >
                        <i className="bi bi-geo-alt"></i> Location permissions
                        disabled
                    </Link>
                    <div className="nav justify-content-end">
                        <a
                            className="nav-link"
                            aria-current="page"
                            href="https://getchaperon.com/privacy"
                        >
                            Privacy Policy
                        </a>
                        <a
                            className="nav-link"
                            aria-current="page"
                            href="https://getchaperon.com/terms"
                        >
                            Terms of Use
                        </a>
                        <Link className="nav-link" to={`/press`}>
                            Press
                        </Link>
                        <Link className="nav-link" to={`/contact`}>
                            Contact
                        </Link>
                        <Link
                            className="nav-link disabled"
                            aria-disabled="true"
                            to={`/`}
                        >
                            Copyright © {currentYear} Nointid Works
                        </Link>
                    </div>
                </nav>
            </div>
        </footer>
    )
}
